/* Ingredient modals (native <dialog>) + Load more reveal. No dependencies. */
(function () {
  // Open / close ingredient modals.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ing-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-ing-open'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      else if (dialog) dialog.setAttribute('open', '');
      return;
    }
    const closer = event.target.closest('[data-ing-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }
    // Backdrop click closes (click landed directly on the <dialog> element).
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('cust-ing-modal')) {
      event.target.close();
    }
  });

  // Load more.
  if (!customElements.get('custom-ingredients')) {
    class CustomIngredients extends HTMLElement {
      connectedCallback() {
        const btn = this.parentElement?.querySelector('[data-ing-loadmore]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          this.querySelectorAll('.cust-ing-card--extra.is-hidden').forEach((c) =>
            c.classList.remove('is-hidden')
          );
          btn.parentElement.remove();
        });
      }
    }
    customElements.define('custom-ingredients', CustomIngredients);
  }
})();
